export const isServerError = (status: number): boolean =>
  status.toString()[0] === '5'
